import {KTSVG} from '../../../../_metronic/helpers'
import AddUserRoleModal from '../Modals/UserManagementModals/AddUserRoleModal'
import AddUserUnitModal from '../Modals/UserManagementModals/AddUserUnitModal'
import UserRoleDeletionModal from '../Modals/UserManagementModals/UserRoleDeletionModal'
import UserUnitDeletionModal from '../Modals/UserManagementModals/UserUnitDeletionModal'

function UserTabContentBar({title, id, searchTerm, setSearchTerm, setAction, isChecked}: any) {
  return (
    <div className='row'>
      <div className='d-flex flex-column flex-md-row justify-content-sm-between '>
        <div className='d-flex flex-column w-md-50'>
          <div>
            <h2>{title}</h2>
            <span>
              Et et consectetur ipsum labore excepteur est proident excepteur ad velit occaecat qui
              minim occaecat veniam. Fugiat veniam incididunt anim aliqua enim pariatur veniam sunt
              est aute sit dolor anim.
            </span>
          </div>
          <div className='d-flex mt-2 bg-light align-items-center w-100 w-xl-450px rounded position-relative square border border-secondary'>
            <KTSVG
              path='/media/icons/duotune/general/gen021.svg'
              className='svg-icon-1 position-absolute ms-5'
            />
            <input
              type='text'
              data-kt-user-table-filter='search'
              className='form-control form-control-solid ps-14'
              placeholder={`Search ${title}`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        <div className='d-flex flex-row flex-wrap'>
          <button
            type='button'
            className='btn  btn-light square border border-dark m-2 h-45px'
            onClick={() => setAction(true)}
          >
            <i className='fa-solid fa-rotate-right' />
          </button>
          <button
            type='button'
            className='btn btn-light square border border-dark m-2  h-45px'
            disabled={isChecked.length > 0 ? false : true}
            data-bs-toggle='modal'
            data-bs-target={`#deleteTabContent${title}_modal`}
          >
            Delete
          </button>

          <button
            type='button'
            className='btn btn-light square border border-dark w-200px h-45px m-2'
            data-bs-toggle='modal'
            data-bs-target={`#createTabContent${title}_modal`}
          >
            Add {title}
          </button>
        </div>
      </div>

      {title === 'Role' ? (
        <>
          <AddUserRoleModal id={id} setAction={setAction} />
          <UserRoleDeletionModal checkList={isChecked} setAction={setAction} />
        </>
      ) : title === 'Unit' ? (
        <>
          <AddUserUnitModal id={id} setAction={setAction} />
          <UserUnitDeletionModal userId={id} checkList={isChecked} setAction={setAction} />
        </>
      ) : null}
    </div>
  )
}

export default UserTabContentBar
